import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  title: string;
  className?: string;
}
const Header: FC<Props> = ({ title, className }) => {
  return (
    <h2
      className={twMerge(
        'md:text-xl text-base/7 font-semibold text-white ',
        className,
      )}
    >
      {title}
    </h2>
  );
};

export default Header;
